/**
 * UserService - Read/write user profiles from Firestore 'users' collection
 */
import { db } from '../firebase';
import { doc, getDoc, setDoc, deleteDoc } from 'firebase/firestore';

const COLLECTION = 'users';

/**
 * Load user profile by uid
 */
export const loadUserProfile = async (uid) => {
  try {
    const snap = await getDoc(doc(db, COLLECTION, uid));
    if (snap.exists()) {
      return snap.data();
    }
    return null;
  } catch (error) {
    console.error('Error loading user profile:', error);
    throw error;
  }
};

/**
 * Save user profile fields (merge)
 */
export const saveUserProfile = async (uid, data) => {
  try {
    await setDoc(doc(db, COLLECTION, uid), data, { merge: true });
  } catch (error) {
    console.error('Error saving user profile:', error);
    throw error;
  }
};

/**
 * Delete user profile document from Firestore
 */
export const deleteUserProfile = async (uid) => {
  try {
    await deleteDoc(doc(db, COLLECTION, uid));
  } catch (error) {
    console.error('Error deleting user profile:', error);
    throw error;
  }
};
